import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-user-technology-data',
  templateUrl: './edit-user-technology-data.component.html',
  styleUrls: ['./edit-user-technology-data.component.scss'],
})
export class EditUserTechnologyDataComponent {}
